import { HttpParams } from '@angular/common/http';
import { EntityItemRequest, EntityItemResponse } from '@jms/model';

// Read-time extras (`EntityItemResponse.options`) belong to the response, not the record. Loaders hand surfaces
// only the record, so the extras ride beside it here, keyed by the record object the loader returned: the record
// contract stays clean, and a different record (switch, reload) never inherits another's extras.
const READ_OPTIONS = new WeakMap<object, Readonly<Record<string, unknown>>>();

/** Query parameters for an item read; `undefined` when no extras are named, so plain reads are unchanged. */
export function entityItemReadParams(request: EntityItemRequest | undefined): HttpParams | undefined {

  return request?.options?.length ? new HttpParams({ fromObject: { options: request.options.join(',') } }) : undefined;
}

/** Called by the item readers on every response, so the extras follow the record they arrived with. */
export function rememberEntityReadOptions<T extends EntityItemResponse>(response: T | null | undefined): T | null | undefined {

  if (response?.item && response.options) READ_OPTIONS.set(response.item, response.options);
  return response;
}

/** The extras read with this record, or undefined when it was read without any (or came from elsewhere). */
export function entityReadOptions(record: unknown): Readonly<Record<string, unknown>> | undefined {

  return record && typeof record === 'object' ? READ_OPTIONS.get(record) : undefined;
}
